import { useContext } from 'react';

import { TeamDialogContext } from '../context/TeamDialogContext';

export const useTeamDialog = () => useContext(TeamDialogContext);
